@defer (when loaded()) {
  <div class="container">
    <div class="left-side-tie">
      @if (leftSideTieInfo(); as tieInfo) {
        <app-tie-scorecard type="draw" [isDraw]="true" [tie]="tieInfo"></app-tie-scorecard>
        <div style="height: 2px;"></div>
        <app-tie-match-list [tie]="tieInfo"></app-tie-match-list>
      }
    </div>
  
    <div class="right-side-tie">
      @if (rightSideTieInfo(); as tieInfo) {
        <app-tie-scorecard type="draw" [isDraw]="true" [tie]="tieInfo"></app-tie-scorecard>
        <div style="height: 2px;"></div>
        <app-tie-match-list [tie]="tieInfo"></app-tie-match-list>
      }
    </div>
  </div>
} @loading (minimum 0.6s) {
  <ion-spinner name="crescent"></ion-spinner>
}
